<template>
  <!-- skeleton loader start -->
  <div class="skeleton-loader">
    <header>
      <div class="container">
        <nav class="navbar navbar-expand-lg p-0">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#offcanvasNavbar"
          >
            <span class="navbar-toggler-icon">
              <i class="ri-menu-line"></i>
            </span>
          </button>
          <a href="index.html">
            <img
              class="img-fluid logo"
              src="assets/images/svg/logo.svg"
              alt="logo"
            />
          </a>
          <a
            target="_blank"
            href="#!"
            data-bs-toggle="modal"
            data-bs-target="#location"
            class="btn btn-sm theme-btn location-btn mt-0 ms-3 d-flex align-content-center gap-1"
          >
            <i class="ri-map-pin-line"></i> Location
          </a>
          <div class="nav-option order-md-2">
            <div class="dropdown-button">
              <div class="cart-button">
                <span>5</span>
                <i class="ri-shopping-cart-line text-white cart-bag"></i>
              </div>
            </div>
            <div class="profile-part dropdown-button order-md-2">
              <img
                class="img-fluid profile-pic"
                src="assets/images/icons/p5.png"
                alt="profile"
              />
              <div>
                <h6 class="fw-normal">Hi, Mark Jecno</h6>
                <h5 class="fw-medium">My Account</h5>
              </div>
            </div>
          </div>
          <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasSkeleton"
          >
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasSkeletonLabel">Menu</h5>
              <button
                class="navbar-toggler btn-close"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#offcanvasSkeleton"
                data-bs-dismiss="offcanvas"
              ></button>
            </div>
            <div class="offcanvas-body">
              <ul class="navbar-nav justify-content-center flex-grow-1">
                <li class="nav-item">
                  <router-link
                    to="/"
                    class="nav-link"
                    exact-active-class="active"
                  >
                    <span>Maps</span></router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    to="/search"
                    class="nav-link"
                    exact-active-class="active"
                  >
                    <span>Order List</span></router-link
                  >
                </li>

                <!-- <li class="nav-item">
                  <a class="nav-link" href="#">Account</a>
                </li> -->
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>

    <section class="home-wrapper section-b-space">
      <div class="container text-center">
        <div class="loader-gif">
          <img
            src="assets/images/gif/food.gif"
            alt="food-gif"
            class="img-fluid"
          />
        </div>
        <h2>Searching the most delicious dish in your area...</h2>
      </div>
    </section>
    <section class="categories-section section-b-space">
      <div class="container">
        <div class="title placeholder-glow">
          <span class="placeholder col-md-2 col-5"></span>
          <p class="placeholder col-5 w-50"></p>
        </div>
        <div class="theme-arrow">
          <div class="swiper categories-slider categories-style">
            <div class="swiper-wrapper">
              <div class="swiper-slide placeholder-glow">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
              <div class="swiper-slide">
                <a href="restaurant-listing.html" class="food-categories">
                  <span class="categories-img"></span>
                  <h4 class="placeholder col-10"></h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="banner-section section-b-space">
      <div class="container">
        <div class="title placeholder-glow">
          <span class="placeholder col-md-2 col-5"></span>
          <p class="placeholder col-5 w-50"></p>
        </div>
        <div class="position-relative">
          <div class="swiper banner1-slider">
            <div class="swiper-wrapper">
              <div class="swiper-slide placeholder-glow">
                <div class="banner-part">
                  <a href="offer.html" class="placeholder"></a>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="banner-part">
                  <a href="offer.html" class="placeholder"></a>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="banner-part">
                  <a href="offer.html" class="placeholder"></a>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="banner-part">
                  <a href="offer.html" class="placeholder"></a>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="banner-part">
                  <a href="offer.html" class="placeholder"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- skeleton loader end -->
</template>

<script setup></script>
